module.exports = __webpack_public_path__ + "img/list5_bg2.26935dd4.png";